const getIdToNameMap = (root) => {
  const map = {}
  if (!root) return map

  const walk = (nodeMap) => {
    if (!nodeMap) return
    Object.values(nodeMap).forEach((node) => {
      if (!node) return
      if (node?._id) map[node._id] = node?.name || node._id
      if (node?.children) walk(node.children)
    })
  }

  walk(root)
  return map
}

export default getIdToNameMap
